$('.nutritional-request').click(function (e) {
    var value = $(this).data('value');
    $('#nutritional-name').val(value);
});

$('#nutritional-form').submit(function (e) {
    e.preventDefault();

    var phone = $('#nutritional-form').find('[name="phone"]');
    var nutritionalName = $('#nutritional-form').find('[name="nutritionalName"]');
    var data = {
        phone: phone.val(),
        name: nutritionalName.val(),
        email: 'supplement',
        comment: 'supplement',
    };

    $.ajax({
        type: $('#nutritional-form').attr('method'),
        url: $('#nutritional-form').attr('action'),
        data: data,
        success: function (response) {
            if (response.result === 'success') {
                phone.val('');
                $('#nutritionalModal').modal('hide');
                $('#nutritionalSuccessMessage').fadeIn();
                setTimeout(function() {
                    $('#nutritionalSuccessMessage').fadeOut();
                }, 3000);
            } else {
                $('#nutritionalErrorMessage').fadeIn();

                setTimeout(function() {
                    $('#nutritionalErrorMessage').fadeOut();
                }, 3000);
            }
        },
        error: function (response) {
            $('#nutritionalErrorMessage').fadeIn();

            setTimeout(function() {
                $('#nutritionalErrorMessage').fadeOut();
            }, 3000);
        }
    });
});
